export default __webpack_public_path__ + "static/media/237.b051d303.jpg";